<template>
  <button
    class="btn"
    :class="button_class"
    :name="button_name"
    :style="{ pointerEvents: pointerEvent }"
    value="true"
    @click="disableButtons"
  >
    <span v-show="!disabled" class="ch-NextButton_Text">{{ active_text }}</span>
    <span v-show="disabled">
      <i class="spinner-border spinner-border-sm"></i>
      <span class="ch-NextButton_WaitText">{{ inactive_text }}</span>
    </span>
  </button>
</template>

<script>
import ButtonCheckoutMixin from "../mixins/ButtonCheckoutMixin";

export default {
  name: "ButtonCheckout",
  mixins: [ButtonCheckoutMixin],
  methods: {
    disableButtons() {
      if (this.$el.form.checkValidity()) {
        this.setPointerEvent("none");
        this.setButtonsDisabled(true);
      }
    },
  },
};
</script>
